import React from "react";
import { $t } from '@/modules/i18n';
import icon from '@/assets/images/icon_9.svg';

export default ({ message = {} }) => (
  <section id="timeline">
    <div className="content">
      <h2 className="section-title">{ $t(message.title) }</h2>
      <div className="line">
      {
        (message.list || []).map((item) => (
          <div className="time" key={item.title}>
            <div className="icon-wrapper">
              <img className="icon" src={icon} alt="point icon" />
              {/* {index !== message.list.length -1 && <div className="icon-line"/>} */}
            </div>
            <div>
              <h4 className="title">{$t(item.title)}</h4>
              { item.desc.map(d => <p className="desc" dangerouslySetInnerHTML={{ __html: $t(d) }}  key={d} />) }
            </div>
          </div>
        ))
      }
      </div>
    </div>
  </section>
);